import { NewTabLink } from "../UI/NewTabLink";

export function ISPGWaitlist(props: { Campus: string, AcadYearLabel: string }) {
    return <div className="OtherData_Container">
        <fieldset className="OtherData">
            <legend>{props.AcadYearLabel} accommodation applications</legend>

            <h2>Postgraduate Late Bookings ({props.Campus})</h2>

            <p>Please read all the information on our main Accommodation pages before submitting your application:</p>

            <p><NewTabLink to='https://www.essex.ac.uk/life/accommodation/apply/late-booking-accommodation'>https://www.essex.ac.uk/life/accommodation/apply/late-booking-accommodation</NewTabLink>.</p>
        </fieldset>
    </div>;
}